import React, { useRef, useEffect } from 'react'
import  style from "./Cover.module.css";
//import video1 from '../../media/videos/Home Video Web.mp4';

const Cover = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  }, []);
  
  return (
    <div className={style.cover} id='home'>
        <video
        ref={videoRef}
        autoplay
        muted
        loop
        controls={true} // Si no quieres mostrar los controles
        className={style.aboutVideo} // Ajuste de tamaño opcional
      ><source src="https://www.dropbox.com/scl/fi/r9y47kephzqlwlj2nadja/HOME-WEB-2025-up.mp4?rlkey=x0z98ei57o153ch7io6a6rc4x&st=yqqcpnrb&raw=1" type="video/mp4" /></video>
    </div>
  )
}

export default Cover
